module.exports = __webpack_public_path__ + "img/alert.ca099e82.png";